import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import styles from "./Confirmation.module.scss";
import printJS from "print-js";

const PrintComponent = ({ t, pdfData }) => {
  const isSafari = useMemo(() => navigator.vendor.indexOf("Apple") !== -1, []);

  const printClick = async () => {
    try {
      if (pdfData) {
        printJS({
          printable: pdfData.pdfFile,
          type: "pdf",
          base64: true
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  if (isSafari) {
    return null;
  }

  return (
    <React.Fragment>
      <button
        className={[
          "btn-lg btn-default print_no_display",
          styles["print_save_margin"]
        ].join(" ")}
        value={t("confirmation.print_receipt")}
        name={t("confirmation.print_receipt")}
        onClick={printClick}
      >
        <i
          className={["fa fa-print", styles["save_icon"]].join(" ")}
          aria-hidden="true"
        ></i>{" "}
        {t("confirmation.print_a_copy")}
      </button>
    </React.Fragment>
  );
};

export default withTranslation("common")(PrintComponent);
